import { render } from "./LatestFolder.vue?vue&type=template&id=7f6ed9da"
import script from "./LatestFolder.vue?vue&type=script&lang=js"
export * from "./LatestFolder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__